import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14300cf3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "blocker"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]

import Viewport from '@/store/modules/Viewport';

export default /*#__PURE__*/_defineComponent({
  __name: 'Blocker',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_unref(Viewport).isTouch)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "blocker__title h1",
          innerHTML: _ctx.$t('blocker.title')
        }, null, 8, _hoisted_2),
        _createElementVNode("div", {
          class: "blocker__subtitle subtitle",
          innerHTML: _ctx.$t('blocker.subtitle')
        }, null, 8, _hoisted_3)
      ]))
    : _createCommentVNode("", true)
}
}

})